import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";

// 导入全局样式
import "./styles/global.css";

// 创建应用
const app = createApp(App);

// 使用Pinia状态管理
const pinia = createPinia();
app.use(pinia);

// 使用路由
app.use(router);

// 移动端优化：禁用双击缩放
let lastTouchEnd = 0;
document.addEventListener(
  "touchend",
  (event) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  },
  false,
);

// 移动端优化：防止页面缩放
document.addEventListener(
  "touchstart",
  (event) => {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  },
  { passive: false },
);

// 挂载应用
app.mount("#app");

// 错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error("Vue错误:", err);
  console.error("组件实例:", instance);
  console.error("错误信息:", info);
};

// 全局性能监控
if (import.meta.env.DEV) {
  window.addEventListener("error", (event) => {
    console.error("全局错误:", event.error);
  });

  window.addEventListener("unhandledrejection", (event) => {
    console.error("未处理的Promise拒绝:", event.reason);
  });
}

// 导出应用实例（用于测试）
export { app };
